var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { UserService } from '~/services/management-service/user.service';
import { Emit } from 'vue-property-decorator';
import { CarManageService } from "~/services/domain-service/car-manage.service";
var AddGarage = /** @class */ (function (_super) {
    __extends(AddGarage, _super);
    function AddGarage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.userList = [];
        _this.dataForm = {
            id: "",
            garageCode: "",
            garageName: "",
            areaIds: [],
            addressDetail: "",
            contactName: "",
            contactPhone: "",
            garageArea: "",
            userIds: [],
            commonState: "",
            remark: "",
        };
        _this.rules = {
            garageCode: { required: true, message: '请输入车库编号' },
            garageName: { required: true, message: '请输入车库名称' },
            areaIds: { required: true, type: 'array', message: '请选择车库地址' },
            addressDetail: { required: true, message: '请输入详细地址' },
            contactName: { required: true, message: '请输入联系人' },
            contactPhone: [
                { required: true, message: '请输入联系电话' },
                { validator: _this.$validator.phoneNumber, trigger: 'blur' }
            ],
            garageArea: { required: true, message: '请输入车库面积' },
            commonState: { required: true, message: '请选择状态' },
            userIds: { required: true, type: 'array', message: '请选择库管员' },
        };
        return _this;
    }
    AddGarage.prototype.refreshList = function () { };
    AddGarage.prototype.close = function () {
        this.reset();
    };
    AddGarage.prototype.mounted = function () {
        this.getAllUserList();
    };
    //重置方法
    AddGarage.prototype.reset = function () {
        var modifyForm = this.$refs["modify-form"];
        console.log("111", this.dataForm.id);
        this.dataForm.id = '';
        modifyForm.resetFields();
    };
    /**
     * 反显数据
     */
    AddGarage.prototype.update = function (data) {
        if (!data.id)
            return;
        this.dataForm.id = data.id;
        this.dataForm.garageCode = data.garageCode;
        this.dataForm.garageName = data.garageName;
        this.dataForm.areaId = data.areaId;
        this.dataForm.addressDetail = data.addressDetail;
        this.dataForm.contactName = data.contactName;
        this.dataForm.contactPhone = data.contactPhone;
        this.dataForm.garageArea = data.garageArea;
        this.dataForm.userIds = data.userIds.split(',');
        this.dataForm.realNames = data.realNames;
        this.dataForm.commonState = data.commonState;
        this.dataForm.remark = data.remark;
        var arr = this.$city.getCityParent(Number(data.areaId));
        this.dataForm.areaIds = arr ? arr.concat([Number(data.areaId)]) : [];
    };
    AddGarage.prototype.commit = function () {
        var _this = this;
        var modifyForm = this.$refs["modify-form"];
        modifyForm.validate(function (valid) {
            if (!valid)
                return false;
            _this.dataForm.areaId = _this.dataForm.areaIds[_this.dataForm.areaIds.length - 1];
            //根据是否有数据传入决定执行新增还是修改
            _this.dataForm.id ? _this.updateGrage() : _this.addGrage();
            _this.close();
        });
    };
    /**
     * 新增车库
     */
    AddGarage.prototype.addGrage = function () {
        var _this = this;
        this.carManageService.addGarage(this.dataForm).subscribe(function (data) {
            _this.$message.success("新增成功!");
            // 刷新列表
            _this.refreshList();
            // 关闭
            _this.close();
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    /**
     * 修改车库
     */
    AddGarage.prototype.updateGrage = function () {
        var _this = this;
        this.carManageService.updateGarage(this.dataForm).subscribe(function (data) {
            _this.$message.success("修改成功!");
            // 刷新列表
            _this.refreshList();
            //关闭
            _this.close();
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    // 库管员列表
    AddGarage.prototype.getAllUserList = function () {
        var _this = this;
        this.userService
            .getAllUsersList({ userStatus: 'ENABLED' })
            .subscribe(function (data) {
            _this.userList = data;
        });
    };
    __decorate([
        Dependencies(CarManageService)
    ], AddGarage.prototype, "carManageService", void 0);
    __decorate([
        Dependencies(UserService)
    ], AddGarage.prototype, "userService", void 0);
    __decorate([
        Emit("refreshList")
    ], AddGarage.prototype, "refreshList", null);
    __decorate([
        Emit('close')
    ], AddGarage.prototype, "close", null);
    AddGarage = __decorate([
        Component({
            components: {}
        })
    ], AddGarage);
    return AddGarage;
}(Vue));
export default AddGarage;
